import MainComponent from "components/Main";

import Select from "components/Select";
import ToggleSwitch from "components/ToggleSwitch";
import SelectDoctor from "components/SelectDoctor";
import ItemClient from "components/ItemClient";
import SelectClient from "components/SelectClient";

export default class SelectReference extends MainComponent {

    constructor(props) {
        super(props);

        this.defaultRecom = {
            recommendationId: null,
            recomEmployerOn: null,
            selectClientShow: null,
            selectDoctor: null,
            recomClientOn: null,
            recomEmployer: null,
            recomClient: null,
            recomDoctor: null,
        };

        this.state = {
            recommendationTypes: [],
            recom: this.defaultRecom
        };

    }

    get value() {
        const { recom } = this.state;
        const { recomDoctor, recomClient, recommendationId } = recom;
        let knowAboutClinicDetails = null;

        if (recommendationId) {

            knowAboutClinicDetails = {
                domainId: null,
                type: recommendationId,
                recommenderClientId: recomClient ? recomClient.id : null,
            };

            if (recommendationId === 6) {
                knowAboutClinicDetails.recommenderEmployeeViaClientId = recomDoctor ? recomDoctor : null;
            } else if (recommendationId === 5) {
                knowAboutClinicDetails.recommenderEmployeeId = recomDoctor ? recomDoctor : null;
            }

        }
        return knowAboutClinicDetails;
    }

    set value(value) {
        this.getRecommendation();

        this.state.recom = this.defaultRecom;

        if (value) {
            const { recommenderClientId, recommenderClient, recommenderEmployeeId, recommenderEmployeeViaClientId, recommendationType } = value;

            this.state.recom.recommendationId = recommendationType.id;
            if (recommendationType.id === 6) {
                this.state.recom.recomClientOn = true;
                this.state.recom.recomEmployerOn = true;

                if (recommenderClientId) {
                    this.state.recom.selectClientShow = true;
                    this.state.recom.recomClient = recommenderClient;
                }

                if (recommenderEmployeeViaClientId) {
                    this.state.recom.selectDoctor = true;
                    this.state.recom.recomDoctor = recommenderEmployeeViaClientId;
                }

            } else if (recommendationType.id === 5) {
                this.state.recom.recomEmployerOn = true;
                if (recommenderEmployeeId) {
                    this.state.recom.selectDoctor = true;
                    this.state.recom.recomDoctor = recommenderEmployeeId;
                }
            }

        }
    }

    async getRecommendation() {
        const recsResp = await this._request.recommendationTypes.getAll();
        const recommendationTypes = recsResp?.data || [];
        this.setState({ recommendationTypes });
    }

    insertSelect(props) {
        return <Select {...props} />;
    }

    insertToggleSwitch(props) {
        return <ToggleSwitch {...props} />;
    }

    insertSelectDoctor(props) {
        return <SelectDoctor {...props} />;
    }

    onChangeKnowAboutClinicId(id) {
        const { recom } = this.state;
        if (id === 5)
            this.changeState("recom", { ...recom, recomEmployerOn: true, recomClientOn: false, recommendationId: id });
        else if (id === 6)
            this.changeState("recom", { ...recom, recomClientOn: true, recomEmployerOn: false, recommendationId: id });
        else {
            this.changeState("recom", { ...this.defaultRecom, recommendationId: id });
        }
    }

    onClickSelectClient(recomClient) {
        const { recom } = this.state;
        this.changeState("recom", { ...recom, recomClient });
    }

    onClickSelectDoctor(recomDoctor) {
        const { recom } = this.state;
        this.changeState("recom", { ...recom, recomDoctor });
    }

    render() {
        const { recom, recommendationTypes } = this.state;
        const { recomClient, recomDoctor, recomEmployerOn, recomClientOn, selectClientShow, selectDoctor, recommendationId } = recom;

        return (<>
            {this.insertSelect({
                value: recommendationId,
                label: "main.learned",
                labelKey: "title",
                showLeftIcon: false,
                placeHolder: "main.notIndicated",
                items: recommendationTypes,
                onChange: this.onChangeKnowAboutClinicId.bind(this)
            })}
            {recomClientOn && this.insertToggleSwitch({
                checked: selectClientShow,
                label: "client.selectClient",
                onChange: this.changeState.bind(this, "recom", { ...recom, selectClientShow: !selectClientShow })
            })}
            {selectClientShow && <>{recomClient ? <ItemClient
                info={recomClient}
                active={true}
                removeCb={this.changeState.bind(this, "recom", { ...recom, recomClient: false })}
            /> : <SelectClient
                searchShow={true}
                onClick={this.onClickSelectClient.bind(this)}
            />
            }</>}
            {selectClientShow && this.insertToggleSwitch({
                checked: selectDoctor,
                label: "client.recommendationForDoctor",
                onChange: this.changeState.bind(this, "recom", { ...recom, selectDoctor: !selectDoctor })
            })}
            {(recomEmployerOn || selectDoctor) && this.insertSelectDoctor({
                value: recomDoctor,
                label: "client.doctor",
                onClick: this.onClickSelectDoctor.bind(this)
            })}
        </>);
    }
}
